import { Button, Space } from "antd";
import VerifiedIcon from "../../assets/icons/VerifiedIcon";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function SuccessfulModal({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal {...rest} handleClose={handleClose} width={400} footer={null}>
      <div className="rounded flex justify-center">
        <div className="bg-[#F2FFF9] p-2">
          <VerifiedIcon />
        </div>
      </div>
      <div className="text-[22px] font-semibold text-center my-2">
        Password Reset Successful
      </div>
      <div className="text-center">
        The password for <span className="text-primary">sBusiness</span> has
        been successfully reset. The user will need to use the new credentials
        to log in. Please ensure the user is informed about the reset for
        seamless access.
      </div>
      <Space className="w-full mt-2 flex justify-center" size={12}>
        <Button
          className="modal-button mt-4"
          type="primary"
          htmlType="submit"
          size="middle"
          onClick={handleClose}
        >
          Ok
        </Button>
      </Space>
    </CustomModal>
  );
}
